import { render, staticRenderFns } from "./materials-list-table-bulks.vue?vue&type=template&id=36a7dcc5&scoped=true"
import script from "./materials-list-table-bulks.vue?vue&type=script&lang=js"
export * from "./materials-list-table-bulks.vue?vue&type=script&lang=js"
import style0 from "./materials-list-table-bulks.vue?vue&type=style&index=0&id=36a7dcc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7dcc5",
  null
  
)

export default component.exports